










import { ProductType } from "@/models/products/product";
import { Vue, Component } from "vue-property-decorator";
import UmbrellaMenu from "@/components/collections/UmbrellaMenu.vue";
import BaseMenu from "@/components/collections/BaseMenu.vue";
import ChairMenu from "@/components/collections/ChairMenu.vue";
import AccessoryMenu from "@/components/collections/AccessoryMenu.vue";
@Component({
  components: {
    UmbrellaMenu,
    BaseMenu,
    ChairMenu,
    AccessoryMenu
  }
})
export default class CollectionMenu extends Vue {
  protected productType = ProductType;
  get product(): string {
    return this.$route.params.product
      ? (this.$route.params.product as ProductType)
      : ProductType.Umbrella; //umbrella is default if null
  }
}
